module.exports = __webpack_public_path__ + "img/tjdx_logo@2x.097d7ca6.png";